import React, { useState } from 'react'
import { withRouter } from 'react-router';
import { TextField, Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow, Tooltip, Tabs, Tab } from '@material-ui/core';
import { read, utils } from 'xlsx';
import { GetApp } from '@material-ui/icons';
import { checkApiStatus, downloadFileType } from '../../../utils_v2';
import { globalPostService, globalExportService } from '../../../utils_v2/globalApiServices';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { trackActivity } from '../../../utils/mixpanel';
import { DropzoneArea } from 'material-ui-dropzone'
import { useSnackbar } from 'notistack';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { castleAirInstance } from '../../../shared_elements/components';

export default function ImportSubSectionCheck({ params, toggleModalFn, type, importCheckList, importSubSections }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [pres, setPres] = useState([]);
    const [questionsData, setQuestionsData] = useState([]);
    const [tempTabIndx, setTempTabIndx] = useState(0);

    const onFieldChange = (e, keyParam, value, index, type) => {
        if(type ==='ques'){
            setQuestionsData(questionsData.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
        }else{
            setPres(pres.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
        }
    }
    const onRemove = (index, type) => {
        if(type ==='ques'){
            setQuestionsData(questionsData.filter((i,itemIndex)=> index !== itemIndex))
         }else{
             setPres(pres.filter((item, itemIndex) => index !== itemIndex))
        }
    }
    const onFilesDrop = (files) => {
        if (files && files.length > 0) {
            setLoading(true);
            const file = files[0];
            if (file instanceof Blob) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const buffer = e.target.result;
                    const wb = read(new Uint8Array(buffer));
                    if (wb.SheetNames.includes("Questions") && wb.SheetNames.includes("Sections") && castleAirInstance) {
                        const questionData = utils.sheet_to_json(wb.Sheets['Questions'], { blankRows: false });
                        const sectionData = utils.sheet_to_json(wb.Sheets['Sections'], { blankRows: false });
                        setQuestionsData(questionData)
                        setPres(sectionData)
                    } else {
                        const ws = wb.Sheets[wb.SheetNames[0]];
                        const data = utils.sheet_to_json(ws, { blankRows: false });
                        if (data.length === 0) {
                            enqueueSnackbar("Invalid Data", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        }
                        setPres(data);
                    }
                };
                setLoading(false);
                reader.readAsArrayBuffer(file);
            } else {
                console.error("Invalid file object. Expected a Blob.");
            }
        }

    }
    const onImportSubSections = () => {
        // Validations for Template Import;
        setLoading(true);
        if (type != 'checkList') {
            let payload = questionsData.length ? {main_sections:pres,questions:questionsData}: {main_sections:pres}
            globalPostService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/import/?asset_type=${params.type}&section_id=${importSubSections?.sectionId}`, payload)
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        window.location.reload();
                        toggleModalFn();
                        trackActivity('Project Management', { event_type: 'Sub Section Import Success', page_title: 'T013 Form', workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '', request_body: pres ? pres : '', response: response.data.data, success_msg: response.data.message });
                    } else {
                        enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        trackActivity('Project Management', { event_type: 'Sub Section Import Failed', page_title: 'T013 Form', workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '', request_body: pres ? pres : '', error_msg: response.data.data, error_source: 'Backend' });
                    }
                })
        }
        else {
            globalPostService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/import/?asset_type=${params.type}&section_id=${importCheckList?.sectionId}&sub_section_id=${importCheckList?.subSectionId}`, {main_sections:pres})
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        window.location.reload();
                        toggleModalFn();
                        trackActivity('Project Management', { event_type: 'Checklist Import Success', page_title: 'T013 Form', workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '', request_body: pres ? pres : '', response: response.data.data, success_msg: response.data.message });
                    } else {
                        enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        trackActivity('Project Management', { event_type: 'Checklist Import Failed', page_title: 'T013 Form', workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '', request_body: pres ? pres : '', error_msg: response.data.data, error_source: 'Backend' });
                    }
                })
        }
    }
    const downloadSampleTemplate = () => {
        if (type != 'checkList') {
             window.open(castleAirInstance? 'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/media-dev/Sample_Template/Sub_Section_Sample_Import_with_Questions_Section.xlsx':`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/media-dev/Sample_Template/Sub_Section_Sample_Import.xlsx`)
                    trackActivity('Project Management', {
                        event_type: 'Sample Sub section Template Downloaded',
                        page_title: 'T013 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        file_name: 'T013_Sample_Template',
                        file_extension: 'xls'
                    });
        }
        else {
            window.open(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/media-dev/Sample_Template/Checklist_Sample_Import.xlsx`)
                    trackActivity('Project Management', {
                        event_type: 'Sample CheckList Template Downloaded',
                        page_title: 'T013 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        file_name: 'T013_Sample_Template',
                        file_extension: 'xls'
                    });
        }
    }
    return (
        <Dialog
            open={true}
            onClose={toggleModalFn}
            className='project-management-modal'
            maxWidth='lg'
        >
            <DialogTitle> Import {type == 'checkList' ? 'CheckList' : 'Sub Section'}  </DialogTitle>
            <DialogContent dividers={true} style={{ paddingTop: 0}}>
                <div style={{ width: "828px", height: "378px" }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                <span> Refer the sample template </span>
                                <Button style={{ fontFamily: '"Conv_IBMPlexSans-Bold"', fontWeight: '700' }} size='small' color='primary' variant='text' aria-controls="simple-menu" aria-haspopup="true" onClick={downloadSampleTemplate} endIcon={<ArrowDropDownIcon fontSize='small' />}> Download </Button>
                            </div>
                    <Grid container spacing={1}>
                        <Grid item sm='12'>
                            <DropzoneArea
                                acceptedFiles={['.xls, .xlsx']}
                                filesLimit={1}
                                maxFileSize={10428800}
                                showPreviewsInDropzone={false}
                                useChipsForPreview={false}
                                showPreviews={false}
                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                dropzoneClass="drag-drop-cnt"
                                maxWidth="sm"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                clearOnUnmount={true}
                                onChange={(files) => onFilesDrop(files)}
                            />
                            <div>
                                {questionsData?.length && castleAirInstance ?
                                    <Tabs
                                        value={tempTabIndx}
                                        onChange={(event, newValue) => { setTempTabIndx(newValue) }}
                                        indicatorColor="primary"
                                        textColor="primary"
                                    >
                                        <Tab label='Sections' />
                                        <Tab label='Questions' />
                                    </Tabs> : null}
                                {pres.length || questionsData?.length?
                                    <Table className='mui-table-format'>
                                        <TableHead>
                                            { castleAirInstance && type != 'checkList' && tempTabIndx ==1?    
                                                <TableRow>
                                                    {type != 'checkList' ? <TableCell>Sub Section Name</TableCell> : null}
                                                    <TableCell>Question(s)</TableCell>
                                                    <TableCell>Answer(s)</TableCell>
                                                    <TableCell>Note(s)</TableCell>
                                                    <TableCell>Action</TableCell>
                                                </TableRow>
                                                                                        :
                                            <TableRow>
                                                {type != 'checkList' ? <TableCell>Sub Section Name</TableCell> : null}
                                                <TableCell>Checklist</TableCell>
                                                <TableCell>Notes</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>}
                                        </TableHead>
                                        <TableBody>
                                             { castleAirInstance && type != 'checkList' && tempTabIndx ==1?
                                             questionsData.map((ques, index) => (
                                                    <TableRow>
                                                        {type != 'checkList' ? <TableCell>
                                                            <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        required
                                                                        id={`Sub-Section_${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={ques['Sub Section Name'] || ''}
                                                                        onChange={(e) => onFieldChange(e, 'Sub Section Name', e.target.value, index, 'ques')}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                    /> 
                                                            </div>
                                                        </TableCell> : null}
                                                        <TableCell>
                                                                <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        required
                                                                        id={`Question_${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={ques['Question'] || ''}
                                                                        onChange={(e) => { onFieldChange(e, 'Question', e.target.value, index, 'ques') }}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                    />
                                                                </div> 
                                                        </TableCell>
                                                        <TableCell>
                                                            <div style={{ width: '200px' }}>
                                                                <TextField
                                                                    required
                                                                    id={`Answer${index}`}
                                                                    fullWidth
                                                                    margin="none"
                                                                    value={ques['Answer'] ? ques['Answer'] : ''}
                                                                    onChange={(e) => { onFieldChange(e, 'Answer', e.target.value, index, 'ques') }}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    variant='outlined'
                                                                />
                                                            </div>
                                                        </TableCell>
                                                         <TableCell>
                                                            <div style={{ width: '200px' }}>
                                                                <TextField
                                                                    required
                                                                    id={`Notes_${index}`}
                                                                    fullWidth
                                                                    margin="none"
                                                                    value={ques['Notes'] ? ques['Notes'] : ''}
                                                                    onChange={(e) => { onFieldChange(e, 'Notes', e.target.value, index, 'ques') }}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    variant='outlined'
                                                                />
                                                            </div>
                                                        </TableCell>
                                                        <TableCell>
                                                            {questionsData.length !== 1 ?
                                                                <DeleteOutlineIcon color='secondary' onClick={() => onRemove(index,'ques')} /> : null
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                                :
                                                pres.map((pre, index) => (
                                                    <TableRow>
                                                        {type != 'checkList' ? <TableCell>
                                                            <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        required
                                                                        id={`Sub-Section_${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pre['Sub Section Name'] || ''}
                                                                        onChange={(e) => onFieldChange(e, 'Sub Section Name', e.target.value, index)}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                    /> 
                                                            </div>
                                                        </TableCell> : null}
                                                        <TableCell>
                                                                <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        required
                                                                        id={`Question_${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pre['Checklist'] || ''}
                                                                        onChange={(e) => { onFieldChange(e, 'Checklist', e.target.value, index) }}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                    />
                                                                </div> 
                                                        </TableCell>
                                                        <TableCell>
                                                            <div style={{ width: '200px' }}>
                                                                <TextField
                                                                    required
                                                                    id={`Notes_${index}`}
                                                                    fullWidth
                                                                    margin="none"
                                                                    value={pre['Notes'] ? pre['Notes'] : ''}
                                                                    onChange={(e) => { onFieldChange(e, 'Notes', e.target.value, index) }}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    variant='outlined'
                                                                />
                                                            </div>
                                                        </TableCell>
                                                        <TableCell>
                                                            {pres.length !== 1 ?
                                                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color='secondary' onClick={() => onRemove(index)} style={{cursor:'pointer'}} /></Tooltip> : null
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table> : null
                                }
                            </div>
                        </Grid>
                        <div>
                            <p className='attachment-note'>Note: Please download "Sample {type == 'checkList'?'Checklist': 'Sub Section(s)'} template", edit the template in Excel and upload the same for further customization. </p>
                            {/* <p className='download-sample-temp' onClick={() => downloadSampleTemplate()} > <GetApp /> Download Sample {type == 'checkList'?'Checklist':'Sub Section(s)'} template</p> */}
                        </div>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color="primary" size='small' variant='outlined'>Cancel</Button>
                {pres.length ?
                    <Button disabled={isLoading} onClick={onImportSubSections} color="primary" size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={20} /> : 'Save'}
                    </Button> : null
                }
            </DialogActions>
        </Dialog>
    )
}